class FlowMemorySingleton {
  constructor() {
    if (FlowMemorySingleton.instance) {
      return FlowMemorySingleton.instance;
    }
    this.lastShownMessageIdForAutoAttachment = null;
    this.agentMessageStarted = true;
    this.isFileParamsPresent = null;
    this.currentAgentUserId = null;
    this.currentAgentImageUrl = null;
    this.aiEmployeeCache = {}; // Cache for AI employee data { [senderId]: { imageUrl, name } }
    FlowMemorySingleton.instance = this;
  }

  setLastShownMessageIdForAutoAttachment(data) {
    this.lastShownMessageIdForAutoAttachment = data;
  }

  getLastShownMessageIdForAutoAttachment() {
    return this.lastShownMessageIdForAutoAttachment;
  }

  setAgentMessageStarted(data) {
    this.agentMessageStarted = data;
  }

  getAgentMessageStarted() {
    return this.agentMessageStarted;
  }

  setIsFileParamsPresent(data) {
    this.isFileParamsPresent = data;
  }

  getIsFileParamsPresent() {
    return this.isFileParamsPresent;
  }

  getCurrentAgentUserId() {
    return this.currentAgentUserId;
  }

  setCurrentAgentUserId(data) {
    this.currentAgentUserId = data;
  }

  getCurrentAgentImageUrl() {
    return this.currentAgentImageUrl;
  }

  setCurrentAgentImageUrl(data) {
    this.currentAgentImageUrl = data;
  }

  getAIEmployeeData(senderId) {
    return this.aiEmployeeCache[senderId] || null;
  }

  setAIEmployeeData(senderId, data) {
    this.aiEmployeeCache[senderId] = data;
  }
}

const flowMemorySingleton = new FlowMemorySingleton();
export default flowMemorySingleton;
